
<template>
  <div>
    <v-row no-gutters justify="center" align="center">
      <v-btn class="n-white-btn n-small-btn n-icon-btn" :disabled="!canGoPreviousPage" @click="page -= 1">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <div class="ml-2">
        {{ pageFrom }} - {{ pageTo }}
      </div>
      <v-btn class="n-white-btn n-small-btn n-icon-btn ml-2" :disabled="!canGoNextPage" @click="page += 1">
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `EquipmentsPager`,
  computed: {
    ...mapState(`ui/equipments`, {
      equipments: `list`,
    }),
    page: {
      get() { return this.$store.state[`ui/equipments`].page; },
      set(page) { this.$store.commit(`ui/equipments/SET_PAGE`, page); },
    },
    pageFrom() { return (this.page - 1) * 10 + 1; },
    pageTo() { return (this.page - 1) * 10 + this.equipments.length; },
    canGoPreviousPage() { return this.page > 1; },
    canGoNextPage() { return this.equipments.length === 10; },
  },
  watch: {
    page() { this.$emit(`change`); },
  },
};
</script>

<style lang="scss">
</style>
